import {
  Component,
  OnInit,
  OnDestroy,
  Input,
  Output,
  EventEmitter,
  ChangeDetectorRef,
  ChangeDetectionStrategy,
} from '@angular/core';
import cloneDeep from 'lodash/cloneDeep';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { RenderedService } from '../../rendered.service';
import { BaseScaffoldComponent } from '../base-scaffold/base-scaffold.component';

@Component({
    selector: 'app-general-card',
    templateUrl: './general-card.component.html',
    styleUrls: ['../../rendered.component.scss', './general-card.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class GeneralCardComponent
  extends BaseScaffoldComponent
  implements OnInit, OnDestroy
{
  active = -1;
  // @Output() setDisplay = new EventEmitter<any>();
  content;
  view = [];

  public destroy$: Subject<boolean> = new Subject<boolean>();
  constructor(
    public cdr: ChangeDetectorRef,
    public renderedService: RenderedService
  ) {
    super(cdr, renderedService);
  }

  ngOnInit() {
    this.renderedService
      .listenForUpdates()
      .pipe(takeUntil(this.destroy$))
      .subscribe(trigger => {
        this.cdr.detectChanges();
      });

    var item = cloneDeep(this.info);

    item.data.content = this.item.content;
    this.content = [item];
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }
}
